import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import CreditSimulatorCRUD from './CreditSimulator';

const CreditSimulator = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Simuador de Prestamo' pageTitle='Prestamos' />
                <CreditSimulatorCRUD />
            </div>
        </React.Fragment>
    )
}

export default CreditSimulator;